import React, { useState, useEffect, useMemo, use } from "react";
import { Card, Form, Input, Select, Upload, Button, InputNumber, Row, Col, Space } from "antd";
import { EyeOutlined } from "@ant-design/icons";
// import UploadButton from "../../common/UploadButton";
import UploadButton from "../common/UploadButton";
// import globalData from "../../../config/global_data";
import globalData from "../../config/global_data";
import ImagePreviewModal from "../common/ImagePreviewModal";


const { Option } = Select;

const MultiKitProductItem = ({ name, store_id, form, product, prodindex,
    groupIndex, setInnerProducts, unique_id }) => {
    const [data, setData] = useState(null);
    const [savedimages, setSavedimgaes] = useState(null);
    const [options, setOptions] = useState([]);
    const [selectedSKU, setSelectedSKU] = useState([]);
    const [selectedProductImage, setSelectedProductImage] = useState(null);
    const [isPreviewVisible, setPreviewVisible] = useState(false);
    const [previewImageUrl, setPreviewImageUrl] = useState("");
    const [previewMeta, setPreviewMeta] = useState("");
    const [previewTitle, setPreviewTitle] = useState("");
    const [currentImage, setCurrentImage] = useState("https://cdn11.bigcommerce.com/s-ww3msiylzo/images/stencil/original/image-manager/image-coming-soon.jpg");

    useEffect(() => {
        if (!store_id) return;
        if (globalData?.bc_sku_list?.length) {
            setOptions(globalData.bc_sku_list.filter(x => x.store_id === store_id));
        }

    }, [store_id, globalData.bc_sku_list]);

    // useEffect(() => {
        // console.log("product ===>", product)
    // }, [product])

    useEffect(() => {
        if (product) {
            setCurrentImage(product?.image || "https://cdn11.bigcommerce.com/s-ww3msiylzo/images/stencil/original/image-manager/image-coming-soon.jpg");
            form?.setFieldValue?.([unique_id, 'productName'], product?.productName);
            form?.setFieldValue?.([unique_id, 'msrp'], product?.msrp);
            form?.setFieldValue?.([unique_id, 'sale_price'], product?.sale_price);
            form?.setFieldValue?.([unique_id, 'image'], product?.image);
            form?.setFieldValue?.([unique_id, 'sku'], product?.sku);
        }
    }, [data, product]);


    const handleChange = (value) => {
        setSelectedSKU(value);
        form?.setFieldValue?.([unique_id, 'sku'], value);
        const selected = options.find(o => o.value === value);
        if (selected) {
            form?.setFieldValue?.([unique_id, 'productName'], selected.product_name);
            form?.setFieldValue?.([unique_id, 'msrp'], selected?.msrp);
            form?.setFieldValue?.([unique_id, 'sale_price'], selected?.sale_price);
            form?.setFieldValue?.([unique_id, 'image'], selected?.image);

            // Set the selected product image
            setSelectedProductImage(selected?.image);
            setCurrentImage(selected.image || "https://cdn11.bigcommerce.com/s-ww3msiylzo/images/stencil/original/image-manager/image-coming-soon.jpg");

            setInnerProducts(prev => {
                const allGroups = prev.multi_kit_prods || [];
                const currentGroup = allGroups[groupIndex] || {};
                const currentProducts = currentGroup.products || [];
                const nextProducts = [...currentProducts];
                nextProducts[prodindex] = {
                    ...nextProducts[prodindex],
                    sku: value,
                    productName: selected.product_name,
                    msrp: selected.msrp,
                    sale_price: selected.sale_price,
                    image: selected.image
                };
                const nextAllGroups = [...allGroups];
                nextAllGroups[groupIndex] = { ...currentGroup, products: nextProducts };
                return {
                    ...prev,
                    multi_kit_prods: nextAllGroups
                };
            });// Update the inner products state

            // Set image in savedimages when SKU is selected
            // if (selected?.image) {
            //     setSavedimgaes({
            //         image_data: [{
            //             thumbUrl: selected.image,
            //             url: selected.image,
            //             name: selected.product_name || 'Product Image',
            //             uid: Date.now().toString(),
            //             status: 'done'
            //         }]
            //     });
            // }
        }
    };


    // useEffect(() => {
    //     const list = savedimages?.image_data || [];
    //     if (list.length > 0) {
    //         const firstUrl = list[0]?.thumbUrl;
    //         if (firstUrl) {
    //             form?.setFieldValue?.([...name, 'image'], firstUrl);
    //         }
    //     } else {
    //         // If all images are removed, clear the image field in the form
    //         form?.setFieldValue?.([...name, 'image'], undefined);
    //     }
    // }, [savedimages, form, name]);
    const handleImageClick = () => {
        setPreviewImageUrl(product?.image);
        setPreviewVisible(true);
    };
    const onPreview = async (file) => {
        let src = file.url || file.thumbUrl;
        let sizeFormatted = 'Unknown size';

        // Try to fetch image size if URL exists
        if (src && !file.originFileObj) {
            try {
                const response = await fetch(src, { method: 'HEAD' }); // HEAD request only fetches headers
                const size = response.headers.get('content-length');
                if (size) {
                    sizeFormatted = `${(parseInt(size, 10) / 1024).toFixed(1)} kB`;
                }
            } catch (err) {
                console.warn('Could not fetch file size:', err);
            }
        } else if (file.originFileObj?.size) {
            sizeFormatted = `${(file.originFileObj.size / 1024).toFixed(1)} kB`;
        }

        // Load image for dimensions
        const image = new Image();
        image.src = src;
        image.onload = () => {
            const format = file.name?.split('.').pop().toUpperCase() || 'IMG';
            const dimensions = `${image.naturalWidth} x ${image.naturalHeight}`;
            const meta = `${format} | ${dimensions} | ${sizeFormatted}`;
            setPreviewMeta(meta);
        };

        setPreviewImageUrl(src);
        setPreviewTitle(file.name || 'Image Preview');
        setPreviewVisible(true);
    };
    const onCopyLink = () => {
        if (previewImageUrl) {
            navigator.clipboard.writeText(previewImageUrl).then(() => {
            }).catch((err) => {
                console.error("Failed to copy link:", err);
            });
        }
    };

    const onDownload = async () => {
        // console.log("previewImageUrl", previewImageUrl)
        if (!previewImageUrl) return;

        try {
            const response = await fetch(previewImageUrl, { mode: 'cors' });
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = previewTitle || "image.jpg";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // clean up
        } catch (err) {
            console.error("Failed to download image:", err);
        }
    };

// update download code
    // const onDownload = async () => {
    //     console.log("previewImageUrl", previewImageUrl);
    //     if (!previewImageUrl) return;
    
    //     try {
    //         // Fetch the image with CORS enabled
    //         const response = await fetch(previewImageUrl, {
    //             method: 'GET', // Use GET method to fetch the image
    //             mode: 'cors',  // CORS mode to ensure the request is cross-origin
    //             headers: {
    //                 // Optional: You can remove Content-Type here to avoid the preflight issue
    //                 'Content-Type': 'image/jpeg', // This will be automatically inferred by the browser
    //             }
    //         });
    
    //         // Check if the response is successful
    //         if (!response.ok) {
    //             throw new Error('Failed to fetch image');
    //         }
    
    //         // Convert the response to a blob (binary data)
    //         const blob = await response.blob();
    //         const url = URL.createObjectURL(blob); // Create a URL for the Blob
    
    //         // Create a temporary <a> element to trigger the download
    //         const link = document.createElement("a");
    //         link.href = url;
    //         link.download = previewTitle || "image.jpg"; // Use the image name or fallback to a default name
    //         document.body.appendChild(link); // Append the link to the DOM
    //         link.click(); // Trigger the download
    //         document.body.removeChild(link); // Remove the link from the DOM after clicking
    
    //         // Clean up the created URL
    //         URL.revokeObjectURL(url);
    
    //         console.log("Download triggered successfully.");
    //     } catch (err) {
    //         console.error("Failed to download image:", err);
    
    //         // If downloading fails, open the image in a new tab
    //         const imageWindow = window.open(previewImageUrl, '_blank');
    //         if (!imageWindow) {
    //             alert("Failed to open image in new tab. Please check your browser's pop-up settings.");
    //         }
    //     }
    // };
    
    


    // Memoize product object to prevent infinite re-renders
    const productObj = useMemo(() => {
        // Use selected product image if available, otherwise use product prop image
        const imageToUse = selectedProductImage || product?.image;

        if (imageToUse) {
            return {
                img_data: [{
                    id: product?.id || Date.now(),
                    url_standard: imageToUse,
                    url_thumbnail: imageToUse,
                    url_tiny: imageToUse,
                    url_zoom: imageToUse,
                    is_thumbnail: true,
                    sort_order: 0
                }]
            };
        }
        return { img_data: [] };
    }, [selectedProductImage, product?.image, product?.id]);

    return (
        <>
            <Form.Item
                label="Product Name"
                name={[unique_id, "productName"]}
                rules={[{ required: true, message: "Product name required" }]}
                // initialValue={product?.productName}
            >
                <Input placeholder="Enter Product Name" disabled />
            </Form.Item>

            <Form.Item
                label="SKU"
                name={[unique_id, "sku"]}
                rules={[{ required: true, message: "Please Select SKU" }]}
                // initialValue={product?.sku}
            >
                <Select
                    // mode="tags"
                    style={{ width: "100%" }}
                    placeholder="Select SKU"
                    onChange={handleChange}
                    options={options}
                    value={selectedSKU}
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />
            </Form.Item>

            {/* <Form.Item
                label={
                    <span>
                        PDP Gallery&nbsp;
                    </span>
                }
                name="PDPGallery"
            >
                <UploadButton 
                    setSavedimgaes={setSavedimgaes}
                    product_obj={productObj}
                    MAX_UPLOADS="1"
                    delete="true"
                    replace="true"
                    thumbnail="true"
                    hover="" 
                />
            </Form.Item> */}
            <Form.Item
                label={
                    <span>
                        PDP Gallery&nbsp;
                    </span>
                }
                // name="PDPGallery"
                className="WiththumnailMainImage"
            >
                {currentImage && currentImage && (
                    <div className="thumnailMainImageBox">
                        <div className="thumnailMainImageBoxInner" onClick={handleImageClick} style={{ cursor: "pointer" }}>
                            <div
                                className="thumnailRelative"
                                onClick={() =>
                                    onPreview({
                                        url: currentImage,
                                        name: "slider-image.jpg", // fake name
                                    })
                                }
                                style={{ position: "relative", cursor: "pointer" }}
                            >
                                <img
                                    className="thumnailImage"
                                    src={currentImage}
                                    alt="Main Thumbnail"
                                    style={{ width: "100px", height: "100px", objectFit: "contain" }}
                                />
                                <div

                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        color: '#fff',
                                        borderRadius: '50%',
                                        padding: 8,
                                        cursor: 'pointer',
                                        opacity: 0,
                                        transition: 'opacity 0.3s',
                                    }}
                                    className="eye-hover"
                                >
                                    <EyeOutlined style={{ fontSize: 20 }} />
                                </div>
                            </div>
                        </div>
                        <div className="thumnailName" style={{ marginTop: "4px" }}>
                            <Space size="small" align="center">
                                <span
                                    style={{
                                        height: 6,
                                        width: 6,
                                        backgroundColor: "#52c41a",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                    }}
                                />
                                <span>Slider Image</span>
                            </Space>
                        </div>
                    </div>
                )}

                <ImagePreviewModal
                    visible={isPreviewVisible}
                    onClose={() => setPreviewVisible(false)}
                    imageSrc={previewImageUrl}
                    title={previewTitle}
                    meta={previewMeta}
                    onCopyLink={onCopyLink}
                    onDownload={onDownload}
                />
                {/* <UploadButton
                  setSavedimgaes={setSavedimgaes}
                  MAX_UPLOADS="1"
                  delete="true"
                  replace="true"
                  thumbnail="true"
                  hover="false"
                  product_obj={imageObj}
                /> */}
            </Form.Item>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label={
                            <span>
                                Store MSRP&nbsp;
                            </span>
                        }
                        name={[unique_id, 'msrp']}
                        // initialValue={product?.msrp}
                    >
                        <Input placeholder="Enter MSRP" disabled />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={
                            <span>
                                Store Sale Price&nbsp;
                            </span>
                        }
                        name={[unique_id, 'sale_price']}
                        // initialValue={product?.sale_price}
                    >
                        <Input
                            placeholder="Enter Sale Price"
                            disabled
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default MultiKitProductItem;